import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import toast from "react-hot-toast";
import Login from "./pages/Login/Login";
import { fetchLocation } from "./API/API";
import Test from "./Test";
import Dashboard from "./pages/Dashboard/Dashboard";
import Home from "./pages/Home/Home";
import ChangeFace from "./pages/ChangeFace/ChangeFace";
import ViewAttendance from "./pages/ViewAttendance/ViewAttendance";
import Profile from "./pages/Profile/Profile";
import Help from "./pages/Help/Help";
import CanteenList from "./pages/CanteenList/CanteenList";
import CanteenPay from "./pages/CanteenList/CanteenPay/CanteenPay";
import TelephoneDirectory from "./pages/TelephoneDirectory/TelephoneDirectory";
import ChangePass from "./pages/ChangePass/ChangePass";
import ApplyLeave from "./pages/ApplyLeave/ApplyLeave";
import BookMeal from "./pages/BookMeal/BookMeal";
import Onboarding from "./pages/Onboarding/Onboarding";
import Page1 from "./pages/Onboarding/components/Page1";
import Page2 from "./pages/Onboarding/components/Page2";
import Page3 from "./pages/Onboarding/components/Page3";
import Page4 from "./pages/Onboarding/components/Page4";
import Page5 from "./pages/Onboarding/components/Page5";
import Page6 from "./pages/Onboarding/components/Page6";
import Page7 from "./pages/Onboarding/components/Page7";
import Page8 from "./pages/Onboarding/components/Page8";
import ManualAttendance from "./pages/ManualAttendance/ManualAttendance";
import TeamAttendance from './pages/TeamAttendance/TeamAttendance';
import OtherSnacks from './pages/Dashboard/components/Tabs/components/OtherSnacks/Othersnacks';
import CanteenMenu from './pages/Dashboard/components/Tabs/components/CanteenMenu/CanteenMenu';
import HospitalList from './pages/HospitalList/HospitalList';

const App = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const onlineHandler = () => {
      setIsOnline(true);
      toast.success("You're Online");
    };

    const offlineHandler = () => {
      setIsOnline(false);
      toast("You're Offline", {
        duration: 4500,
        icon: "❗",
      });
    };

    window.addEventListener("online", onlineHandler);
    window.addEventListener("offline", offlineHandler);

    return () => {
      window.removeEventListener("online", onlineHandler);
      window.removeEventListener("offline", offlineHandler);
    };
  }, []);

  return (
    <>
      <Routes>
        <Route path="*" element={<Login />} />
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} replace={true}>
          <Route path="/dashboard/home" element={<Home />} />
          <Route path="/dashboard/changeface" element={<ChangeFace />} />
          <Route path="/dashboard/profile" element={<Profile />} />
          <Route path="/dashboard/help" element={<Help />} />
          {/* <Route path="/dashboard/OtherSnacks" element={<OtherSnacks />} /> */}
          <Route
            path="/dashboard/viewattendance"
            element={<ViewAttendance />}
          />
          <Route path="/dashboard/canteenlist" element={<CanteenList />} />
          <Route path="/dashboard/canteenpay" element={<CanteenPay />} />

          <Route
            path="/dashboard/manualattendance"
            element={<ManualAttendance />}
          />

          <Route 
            path="/dashboard/hospitallist"
            element={<HospitalList />}
          /> 

          <Route
            path="/dashboard                                                                                                                                                 d/bookmeal"
            element={<BookMeal />}
          />
          <Route
            path="/dashboard/telephonedirectory"
            element={<TelephoneDirectory />}
          />

          {/* <Route 
           path="/dashboard/othersnacks"
           element= {<OtherSnacks />}     
          />   */}

          {/* <Route 
           path="/dashboard/canteenmenu"
           element= {<CanteenMenu />}     
          /> */}
          

          <Route
            path="/dashboard/TeamAttendance"
            element={<TeamAttendance />}
          />

          <Route path="/dashboard/applyleave" element={<ApplyLeave />} />
          <Route path="/dashboard/changepass" element={<ChangePass />} />
        </Route>
        <Route path="/test" element={<Test />} />
        <Route path="/onboarding" element={<Onboarding />}>
          <Route path="/onboarding/1" element={<Page1 />} />
          <Route path="/onboarding/2" element={<Page2 />} />
          <Route path="/onboarding/3" element={<Page3 />} />
          <Route path="/onboarding/4" element={<Page4 />} />
          <Route path="/onboarding/5" element={<Page5 />} />
          <Route path="/onboarding/6" element={<Page6 />} />
          <Route path="/onboarding/7" element={<Page7 />} />
          <Route path="/onboarding/8" element={<Page8 />} />
        </Route>
      </Routes>
    </>
  );
};

export default App;







